import { render, staticRenderFns } from "./ApexCharts.vue?vue&type=template&id=97844a3e&"
import script from "./ApexCharts.vue?vue&type=script&lang=js&"
export * from "./ApexCharts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports